module.exports = __webpack_public_path__ + "img/module.f98f4ceb.svg";